/* Package JSON Import will be here */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */
import DailyDetailsComponent from './dailyDetails.Component';
import { Constants } from "../../../config/appConstants";
import { ApiUrls } from "../../../services/api";
import Api from "../../../services/api/serviceCall";
import { MessageBox } from "../../sharedComponent/messageBox";
import { bindActionCreators } from "redux";
import * as onDefaultGroupByAction from '../../../actions/timecardDefaultGroupBy.Action';
/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class DailyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savedDailyDetailList: [],
            dailyDetailList: [
                {
                    id: 0,
                    createdDate: "",
                    projectId: "",
                    projectNumber: "",
                    projectName: "",
                    weather: "",
                    subsOrVisitors: "",
                    isDeleted: false,
                    status: "",
                    inspections: [
                        {
                            id: 0,
                            description: "",
                            initial: "",
                            isDeleted: false,
                        },
                    ],
                    equipments: [
                        {
                            id: 0,
                            equipmentListId: null,
                            equipmentDescription: "",
                            equipmentValue: "",
                            productiveHours: "",
                            idleHours: "",
                            isDeleted: false,
                        },
                    ],
                },
            ],
            projectOptions: [],
            equipmentOptions: [],
            openModal: false,
            fromDate: "",
            toDate: "",
            isAllowToEdit: true,
            isNewStatus: false,
            selectedDate: new Date(),
            isSaveButtonDisabled: false
        };
    }

    componentWillMount() {
        let paramsObj = this.props.history.location.state;
        const { dailyDetailList } = this.state;
        if(!paramsObj){
            this.props.history.push("/TimeCard");
        }
        else{
            this.setState(
                {
                    savedDailyDetailList: _.cloneDeep(dailyDetailList),
                    fromDate: paramsObj.fromDate,
                    toDate: paramsObj.toDate,
                    isAllowToEdit: paramsObj.isAllowToEdit,
                    isNewStatus: paramsObj.isNewStatus ? paramsObj.isNewStatus : false,
                    selectedDate: paramsObj.selectedDate
                        ? new Date(paramsObj.selectedDate)
                        : new Date(),
                },
                () => {
                    this.getDailyDetails();
                    this.getProjectList();
                    this.getEquipmentList();
                }
            );
        }
    }

    getHoursValue(e) {
        e = e.trim();
        let hourValue = e === '.' ? e : isNaN(e) ? 0 : e;
        let hour = (typeof (hourValue) === "string" && hourValue.replace(/[^\d\.*]+/g, '')) ? hourValue.replace(/[^\d\.*]+/g, '') : 0;
        hour = hour != 0 ? hour.replace(/^0+/, '') : hour == '0.' ? hour : '0';
        return hour;
    }

    onClickAddDailyDetails() {
        let { dailyDetailList } = this.state;
        dailyDetailList.push({
            id: 0,
            createdDate: "",
            projectId: "",
            projectNumber: "",
            projectName: "",
            weather: "",
            subsOrVisitors: "",
            status: "",
            isDeleted: false,
            inspections: [
                {
                    id: 0,
                    description: "",
                    initial: "",
                    isDeleted: false,
                },
            ],
            equipments: [
                {
                    id: 0,
                    equipmentValue: "",
                    equipmentDescription: "",
                    productiveHours: "",
                    idleHours: "",
                    isDeleted: false,
                },
            ],
        });
        this.setState({ dailyDetailList });
    }

    onAddInspection(index) {
        let { dailyDetailList } = this.state;
        let dailyDetail = dailyDetailList[index];
        dailyDetail.inspections.push({
            id: 0,
            description: "",
            initial: "",
            isDeleted: false,
        });
        this.setState({ dailyDetailList });
    }

    onAddEquipment(index) {
        let { dailyDetailList } = this.state;
        let dailyDetail = dailyDetailList[index];
        dailyDetail.equipments.push({
            id: 0,
            equipmentListId: null,
            equipmentValue: "",
            equipmentDescription: "",
            productiveHours: "",
            idleHours: "",
            isDeleted: false,
        });
        this.setState({ dailyDetailList });
    }

    handleInputChange = (event, index, inputName, subIndex) => {
        let { dailyDetailList, projectOptions, equipmentOptions } = this.state;
        let editedDailyDetails = dailyDetailList[index];
        switch (inputName) {
            case Constants.PROJECT_DROPDOWN:
                let projectOption = projectOptions.find((a) => a.value === event.value);
                editedDailyDetails.projectId = projectOption.projectid;
                editedDailyDetails.projectName = projectOption.projectname;
                editedDailyDetails.projectNumber = projectOption.projectnumber;
                break;
            case Constants.WEATHER_FIELD:
                editedDailyDetails.weather = event.value;
                break;
            case Constants.SUBS_OR_VISITORS:
                editedDailyDetails.subsOrVisitors = event.value;
                break;
            case Constants.INSPECTION_DESCRIPTION:
                editedDailyDetails.inspections[subIndex].description = event.value;
                break;
            case Constants.INITIAL_FIELD:
                editedDailyDetails.inspections[subIndex].initial = event.value;
                break;
            case Constants.EQUIPMENT_DROPDOWN:
                let statusCodeListOption = equipmentOptions.find((a) => a.value === event.value);
                if ((statusCodeListOption.equipmentid === null && statusCodeListOption.text === "Select Description-") ||
                    statusCodeListOption.equipmentdescription === Constants.OTHER) {
                    editedDailyDetails.equipments[subIndex].equipmentListId = null;
                    editedDailyDetails.equipments[subIndex].equipmentDescription = "";
                    editedDailyDetails.equipments[subIndex].equipmentValue = statusCodeListOption.text === Constants.OTHER ? statusCodeListOption.equipmentdescription : "";
                } else {
                    editedDailyDetails.equipments[subIndex].equipmentListId = statusCodeListOption.equipmentid;
                    editedDailyDetails.equipments[subIndex].equipmentDescription = statusCodeListOption.equipmentdescription;
                    editedDailyDetails.equipments[subIndex].equipmentValue = statusCodeListOption.equipmentdescription;
                }
                break;
            case Constants.EQUIPMENT_DESCRIPTION:
                editedDailyDetails.equipments[subIndex].equipmentDescription = event.value;
                break;
            case Constants.IDLE_HOURS:
                if(Constants.HOURS_REGEX.test(event.value)){
                    let idleHour = event.value ? this.getHoursValue(event.value) : '';
                    editedDailyDetails.equipments[subIndex].idleHours = idleHour;
                }
                break;
            case Constants.PRODUCTIVE_HOURS:
                if(Constants.HOURS_REGEX.test(event.value)){
                    let productiveHour = event.value ? this.getHoursValue(event.value) : '';
                    editedDailyDetails.equipments[subIndex].productiveHours = productiveHour;
                }
                break;
            default:
                break;
        }
        dailyDetailList[index] = editedDailyDetails;
        this.setState({ dailyDetailList });
    }

    onClickDailyDetailDelete(index) {
        let { dailyDetailList } = this.state;
        let dailyData = dailyDetailList[index];
        if (dailyData.id > 0) {
            dailyData.isDeleted = true;
        }else{
            dailyDetailList.splice(index, 1);
        }
        this.setState({ dailyDetailList });
    }

    onClickInspectionDelete(index, subIndex) {
        let { dailyDetailList } = this.state;
        let deleteDailyDetails = dailyDetailList[index];
        let deleteInspection = deleteDailyDetails.inspections[subIndex];
        if (deleteInspection.id > 0) {
            deleteInspection.isDeleted = true;
        }else{
            deleteDailyDetails.inspections.splice(subIndex, 1);
        }
        this.setState({ dailyDetailList });
    }

    onClickEquipmentDelete(index, subIndex) {
        let { dailyDetailList } = this.state;
        let deleteDailyDetails = dailyDetailList[index];
        let deleteEquipment = deleteDailyDetails.equipments[subIndex];
        if (deleteEquipment.id > 0) {
            deleteEquipment.isDeleted = true;
        }else{
            deleteDailyDetails.equipments.splice(subIndex, 1);
        }
        this.setState({ dailyDetailList });
    }

    getProjectList() {
        let requestData = {};
        let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPBDID_M}?deviceId=${this.props.user.deviceId}`;
        Api.Post(url, requestData, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {
                    let projectList = responseData.data.sort((a, b) => b.projectNumber - a.projectNumber).map((a) => {
                        return {
                            key: a.id,
                            text: `${a.projectNumber}-${a.projectName}`,
                            value: a.id,
                            projectid: a.id,
                            projectname: a.projectName,
                            projectnumber: a.projectNumber,
                        };
                    });
                    this.setState({
                        projectOptions: projectList,
                    });
                } else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            } catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    getEquipmentList() {
        let requestData = {};
        let url = `${ApiUrls.Routes.EQMT_C}${ApiUrls.Routes.GT_EQMT_LT_M}`;
        Api.Post(url, requestData, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {
                    let equipmentList = responseData.data.sort((a, b) => a.displayText - b.displayText).map((a) => {
                        return {
                            key: a.id,
                            text: a.displayText,
                            value: a.displayText,
                            equipmentid: a.id,
                            equipmentdescription: a.displayText,
                        };
                    });
                    let emptyEquipment = { key: null, text: 'Select Description-', value: 'Select Description-', equipmentid: null };
                    this.setState({
                        equipmentOptions: [emptyEquipment, ...equipmentList],
                    });

                } else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            } catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    getDailyDetails() {
        let { fromDate, toDate, isNewStatus } = this.state;
        let url = `${ApiUrls.Routes.DALY_DET_C}${ApiUrls.Routes.GT_DALY_DET_LT_M}?fromDate=${fromDate}&toDate=${toDate}&isNewStatus=${isNewStatus}&deviceId=${this.props.user.deviceId}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success && responseData.data.length > 0) {
                let dailyDetailsList = responseData.data.map(a => {
                    let inspectionList = a.dailyInspections.map(b => {
                        return {
                            id: b.id, description: b.description ?? "", initial: b.inspectionInitial ?? "", isDeleted: b.isDeleted,
                            dailyDetailsId: b.dailyDetailsId, deviceId: b.deviceId
                        };
                    });
                    if (a.status === Constants.IN_PROGRESS && inspectionList.length === 0) {
                        inspectionList.push({
                            id: 0,
                            description: "",
                            initial: "",
                            isDeleted: false
                        });
                    }
                    let equipmentList = a.dailyEquipments.map(b => {
                        return {
                            id: b.id, equipmentDescription: b.description ?? "", equipmentListId: b.equipmentListId,
                            equipmentValue: !b.description || !b.isOther ? b.description ?? "" : Constants.OTHER,
                            productiveHours: b.productiveHours ?? "", idleHours: b.idleHours ?? "", isDeleted: b.isDeleted,
                            dailyDetailsId: b.dailyDetailsId, deviceId: b.deviceId
                        }
                    });
                    if (a.status === Constants.IN_PROGRESS && equipmentList.length === 0) {
                        equipmentList.push({
                            id: 0,
                            equipmentValue: '',
                            equipmentListId: null,
                            equipmentDescription: "",
                            productiveHours: "",
                            idleHours: "",
                            isDeleted: false
                        });
                    }
                    return {
                        id: a.id,
                        deviceId: a.deviceId,
                        createdDate: a.createdDate,
                        projectId: a.projectId,
                        projectNumber: a.projectNumber,
                        projectName: a.projectName,
                        weather: a.weather ?? "",
                        subsOrVisitors: a.subsOrVisitors ?? "",
                        isDeleted: a.isDeleted,
                        status: a.status,
                        inspections: inspectionList,
                        equipments: equipmentList,
                    };
                });
                this.setState({ dailyDetailList: dailyDetailsList, savedDailyDetailList: _.cloneDeep(dailyDetailsList) });
            }
        });
    }

    onGoBack() {
        const { isAllowToEdit, savedDailyDetailList, dailyDetailList } = this.state;

        if (isAllowToEdit && !_.isEqual(dailyDetailList, savedDailyDetailList)) {
            this.setState({ openModal: true });
        } else {
            this.props.history.goBack();
        }
    }

    onClickBackBtn() {
        this.props.history.goBack();
    }

    closeModal() {
        this.setState({ openModal: false });
    }

    async onClickSaveBtn() {
        let { dailyDetailList, selectedDate } = this.state;
        this.setState({ isSaveButtonDisabled: true }, async () => {
            let data = dailyDetailList.filter((p) => p.projectId === "");
            if (data.length === 0) {
                this.props.groupByInTimecardPage('');
                if (dailyDetailList.length > 0 && dailyDetailList.every(a => a.status === Constants.NEW_STATUS)) {
                    this.props.history.push("/Timecard");
                    return;
                }
                let isSuccess = false;
                for (let i = 0; i < dailyDetailList.length; i++) {
                    let equipmentWithInvalidIdleHours = dailyDetailList[i].equipments &&
                        dailyDetailList[i].equipments.filter((t) => Number(t.idleHours) > 24);
                    if (equipmentWithInvalidIdleHours.length > 0) {
                        MessageBox(Constants.IDLE_HOURS_SHOULD_NOT_EXCEED, Constants.ERROR);
                        this.setState({ openModal: false, isSaveButtonDisabled: false })
                        return;
                    }
                    let equipmentWithInvalidProductiveHours = dailyDetailList[i].equipments &&
                        dailyDetailList[i].equipments.filter((t) => Number(t.productiveHours) > 24);
                    if (equipmentWithInvalidProductiveHours.length > 0) {
                        MessageBox(Constants.PRODUCTIVE_HOURS_SHOULD_NOT_EXCEED, Constants.ERROR);
                        this.setState({ openModal: false, isSaveButtonDisabled: false })
                        return;
                    }
                }

                let dailyDetailsForAdd = dailyDetailList.filter(a => a.status !== Constants.NEW_STATUS);
                if (dailyDetailsForAdd.length > 0) {
                    let saveDailyDetailList = dailyDetailsForAdd.map(a => {
                        return {
                            id: a.id,
                            createdDate: new Date(selectedDate),
                            deviceId: this.props.user.deviceId,
                            deviceName: this.props.user.deviceEmpID,
                            projectId: a.projectId,
                            projectNumber: a.projectNumber,
                            projectName: a.projectName,
                            weather: a.weather,
                            inspectionList: this.constructInspection(a.inspections, selectedDate, a.id),
                            equipmentList: this.constructEquipment(a.equipments, selectedDate, a.id),
                            subsOrVisitors: a.subsOrVisitors,
                            status: Constants.IN_PROGRESS,
                            modifiedDate: new Date(),
                            isIncludeSync: true,
                            isDeleted: a.isDeleted,
                            creationDate: new Date(),
                        };
                    });
                    let url = `${ApiUrls.Routes.DALY_DET_C}${ApiUrls.Routes.SV_DALY_DET_M}`;
                    await Api.Post(url, saveDailyDetailList, this, false).then(responseData => {
                        if (responseData.success) {
                            isSuccess = true;
                        }
                    });
                }
                if (isSuccess) {
                    this.props.history.push("/Timecard");
                }
            } else {
                this.setState({ openModal: false, isSaveButtonDisabled: false });
                MessageBox(Constants.PLEASE_SELECT_PROJECT, Constants.ERROR);
            }
        })
    }

    constructInspection(inspectionList, selectedDate, dailyDetailsId) {
        inspectionList = inspectionList.filter(a => a.id > 0 || a.initial.trim() !== "" || a.description.trim() !== "");
        let newInspectionList = [];
        for (let inspection of inspectionList) {
            newInspectionList.push({
                deviceId: this.props.user.deviceId,
                deviceName: this.props.user.deviceEmpID,
                createdDate: new Date(selectedDate),
                description: inspection.description !== null ? inspection.description.trim() : "",
                inspectionInitial: inspection.initial !== null ? inspection.initial.trim() : "",
                creationDate: new Date(),
                modifiedDate: new Date(),
                isIncludeSync: true,
                isDeleted: inspection.isDeleted ? true : (inspection.initial.trim() === "" && inspection.description.trim() === ""),
                dailyDetailsId: dailyDetailsId
            });
        }
        return newInspectionList;
    }

    constructEquipment(equipmentList, selectedDate, dailyDetailsId) {
        equipmentList = equipmentList.filter(a => a.id > 0 || a.equipmentDescription.trim() !== "" || a.productiveHours !== "" || a.idleHours !== "");
        let newEquipmentList = [];
        for (let equipment of equipmentList) {
            newEquipmentList.push({
                deviceID: this.props.user.deviceId,
                deviceName: this.props.user.deviceEmpID,
                createdDate: new Date(selectedDate),
                description: equipment.equipmentDescription !== null ? equipment.equipmentDescription.trim() : "",
                equipmentListId: equipment.equipmentListId,
                productiveHours: this.hoursFormation(equipment.productiveHours),
                idleHours: this.hoursFormation(equipment.idleHours),
                creationDate: new Date(),
                modifiedDate: new Date(),
                isIncludeSync: true,
                isDeleted: equipment.isDeleted ? true : (equipment.equipmentDescription.trim() === "" && equipment.productiveHours === "" && equipment.idleHours === ""),
                dailyDetailsId: dailyDetailsId
            });
        }
        return newEquipmentList;
    }

    hoursFormation(hour) {
        hour = hour.toString();
        return isNaN(parseFloat(hour)) ? "" : Number(parseFloat(hour).toFixed(2)).toString();
    }

    render() {
        const { dailyDetailList, projectOptions, equipmentOptions, openModal, isAllowToEdit, isSaveButtonDisabled } = this.state;
        return (
            <Fragment>
                <DailyDetailsComponent
                    {...{
                        dailyDetails: {
                            dailyDetailList,
                            projectOptions,
                            equipmentOptions,
                            openModal,
                            isAllowToEdit,
                            isSaveButtonDisabled
                        }
                    }}
                    onClickAddDailyDetails={this.onClickAddDailyDetails.bind(this)}
                    onAddEquipment={this.onAddEquipment.bind(this)}
                    onAddInspection={this.onAddInspection.bind(this)}
                    handleInputChange={this.handleInputChange.bind(this)}
                    onClickDailyDetailDelete={this.onClickDailyDetailDelete.bind(this)}
                    onClickEquipmentDelete={this.onClickEquipmentDelete.bind(this)}
                    onClickInspectionDelete={this.onClickInspectionDelete.bind(this)}
                    onGoBack={this.onGoBack.bind(this)}
                    onClickBackBtn={this.onClickBackBtn.bind(this)}
                    closeModal={this.closeModal.bind(this)}
                    onClickSaveBtn={this.onClickSaveBtn.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, onDefaultGroupByAction), dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DailyDetails));

DailyDetails.displayName = 'DailyDetails';